// extracted by mini-css-extract-plugin
export default {"label":"PopupOpenerButton_label__S6iH4 chip","labelSelected":"PopupOpenerButton_labelSelected__OCbI3 chip","labelEllipsis":"PopupOpenerButton_labelEllipsis__WkXuP"};